<script setup lang="ts">
import { computed, onUnmounted, ref } from 'vue';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import dataURLToFile from '@idem/common/util/foto-utils';

const props = defineProps<{ foto: File }>();
const emit = defineEmits<{ confirm: [file: File] }>();

const fotoUrl = computed(() => URL.createObjectURL(props.foto));
const fotoCroppeada = ref<File>();

const onCrop = cropper => {
  if (cropper.canvas.toDataURL() === 'data:,') return;
  fotoCroppeada.value = dataURLToFile(cropper.canvas.toDataURL('image/jpeg', 0.5), 'foto.jpg');
};

function confirmar() {
  if (!fotoCroppeada.value) return;
  emit('confirm', fotoCroppeada.value);
}

onUnmounted(() => URL.revokeObjectURL(fotoUrl.value));
</script>

<template>
  <div
    class="fixed top-1/2 left-1/2 z-50 h-[90vh] w-[90vw] -translate-x-1/2 -translate-y-1/2 bg-white border-2"
  >
    <cropper
      :stencil-props="{ aspectRatio: 1.2578125, movable: true, resizable: true }"
      :resize-image="false"
      class="h-4/5 w-full"
      :src="fotoUrl"
      @change="onCrop"
    ></cropper>
    <button
      type="button"
      data-testid="boton-aceptar"
      class="mx-4 mt-4 rounded bg-teal-600 px-4 py-2 text-white hover:bg-teal-700"
      @click="confirmar"
    >
      Aceptar
    </button>
  </div>
</template>

<style scoped></style>
